/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Toolbar_TypeInputs */

const id_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis`)
};

const ms_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis`)
};

const da_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const de_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ`)
};

const en_us2_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const es_es2_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const es_mx2_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const fil_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uri`)
};

const fr_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const it_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const hu_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Típus`)
};

const nl_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const no_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const pl_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ`)
};

const pt_br2_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const pt_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const ro_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tip`)
};

const fi_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tyyppi`)
};

const sv_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ`)
};

const vi_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại`)
};

const tr_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tür`)
};

const cs_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ`)
};

const bg_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип`)
};

const ru_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип`)
};

const uk_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип`)
};

const ar_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النوع`)
};

const hi_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रकार`)
};

const th_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ประเภท`)
};

const ja_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイプ`)
};

const zh_cn2_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const zh_hant1_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const ko_table_toolbar_type = /** @type {(inputs: Table_Toolbar_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

/**
* | output |
* | --- |
* | "Type" |
*
* @param {Table_Toolbar_TypeInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const table_toolbar_type = /** @type {((inputs?: Table_Toolbar_TypeInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Toolbar_TypeInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_table_toolbar_type(inputs)
	if (locale === "ms") return ms_table_toolbar_type(inputs)
	if (locale === "da") return da_table_toolbar_type(inputs)
	if (locale === "de") return de_table_toolbar_type(inputs)
	if (locale === "en-US") return en_us2_table_toolbar_type(inputs)
	if (locale === "es-ES") return es_es2_table_toolbar_type(inputs)
	if (locale === "es-MX") return es_mx2_table_toolbar_type(inputs)
	if (locale === "fil") return fil_table_toolbar_type(inputs)
	if (locale === "fr") return fr_table_toolbar_type(inputs)
	if (locale === "it") return it_table_toolbar_type(inputs)
	if (locale === "hu") return hu_table_toolbar_type(inputs)
	if (locale === "nl") return nl_table_toolbar_type(inputs)
	if (locale === "no") return no_table_toolbar_type(inputs)
	if (locale === "pl") return pl_table_toolbar_type(inputs)
	if (locale === "pt-BR") return pt_br2_table_toolbar_type(inputs)
	if (locale === "pt") return pt_table_toolbar_type(inputs)
	if (locale === "ro") return ro_table_toolbar_type(inputs)
	if (locale === "fi") return fi_table_toolbar_type(inputs)
	if (locale === "sv") return sv_table_toolbar_type(inputs)
	if (locale === "vi") return vi_table_toolbar_type(inputs)
	if (locale === "tr") return tr_table_toolbar_type(inputs)
	if (locale === "cs") return cs_table_toolbar_type(inputs)
	if (locale === "bg") return bg_table_toolbar_type(inputs)
	if (locale === "ru") return ru_table_toolbar_type(inputs)
	if (locale === "uk") return uk_table_toolbar_type(inputs)
	if (locale === "ar") return ar_table_toolbar_type(inputs)
	if (locale === "hi") return hi_table_toolbar_type(inputs)
	if (locale === "th") return th_table_toolbar_type(inputs)
	if (locale === "ja") return ja_table_toolbar_type(inputs)
	if (locale === "zh-CN") return zh_cn2_table_toolbar_type(inputs)
	if (locale === "zh-Hant") return zh_hant1_table_toolbar_type(inputs)
	return ko_table_toolbar_type(inputs)
});
export { table_toolbar_type as "table.toolbar.type" }